<template>
  <div class="menuBody" style="margin-left:25px;">
          <OrganizationalStructure @AllData="getMsgFormSon" />
    <div class="menuTool" style="width:98%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:170px;float:left;margin-right:30px">
                 <el-input placeholder="请输入归属公司" size="small"     v-model="company"></el-input>
            </div>
             <div style="width:170px;float:left;margin-right:30px">
                 <el-input placeholder="请输入归属部门" size="small"     v-model="department"></el-input>
            </div>
            <div style="width:170px;float:left;margin-right:30px">
                 <el-input placeholder="请输入登录名" size="small"     v-model="LoginNm"></el-input>
            </div>
            <div style="width:170px;float:left;margin-right:30px;">
                 <el-input placeholder="请输入姓名" size="small"     v-model="UserNm"></el-input>
            </div>
            <div style="width:130px;float:left;margin-right:30px;">
                 <el-input placeholder="请输入工号" size="small"     v-model="instrument"></el-input>
            </div>
            <div style="width:130px;float:left;margin-right:30px">
                <el-select  clearable v-model="value" placeholder="请选择状态" size="small">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div style="width:130px;float:left;margin-right:30px">
                <el-select  clearable v-model="valueone" placeholder="请选择类型" size="small">
                    <el-option v-for="item in optionsone" :key="item.valueone" :label="item.labelone" :value="item.valueone"></el-option>
                </el-select>
            </div>
            <div style="float:left;margin-top:10px;">
                <el-button type="primary" size="small" plain   style="background: #246CE5;color:#fff;border-radius:9px;"  v-Jurisdiction="'sys:web:user:manage:list'"  @click="Inquire()">查询</el-button>
            </div>
    <el-table tooltip-effect="light"   :data="tableData"    v-loading="loading"
    style="overflow-y: scroll;float:right;margin-top:30px" row-key="id" 
    border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column  label="归属公司"  show-overflow-tooltip>
                <template slot-scope="scope">
              {{scope.row.companyName}}
              </template>
    </el-table-column>
    <el-table-column prop="officeName" label="归属部门"  show-overflow-tooltip></el-table-column>
    <el-table-column prop="loginName" label="登录名"  show-overflow-tooltip></el-table-column>
    <el-table-column prop="userName" label="姓名"  show-overflow-tooltip></el-table-column>
    <el-table-column prop="mobile" label="手机"  show-overflow-tooltip></el-table-column>
    <el-table-column prop="userType" label="角色"  show-overflow-tooltip></el-table-column>
    <el-table-column prop="InstitutionRemark" label="外包公司"  show-overflow-tooltip></el-table-column>
    <el-table-column prop="InstitutionRemark" label="状态"   show-overflow-tooltip></el-table-column>
    <el-table-column prop="userLastLoginDate" label="最后登录时间"   show-overflow-tooltip></el-table-column>
    <el-table-column fixed="right" label="操作" width="150px">
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" title="修改"
           v-Jurisdiction="'sys:web:user:manage:edit'"></el-button>
          <el-button @click="addNextMenu(scope.row)" type="success" icon="el-icon-refresh"  circle size="small" title="密码重置"
           v-Jurisdiction="'sys:web:user:manage:resetPwd'"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="删除"  v-debounce
           v-Jurisdiction="'sys:web:user:manage:del'"></el-button>
        </template>
    </el-table-column>
  </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
    <UserManDialog :param="diaLogData" ref="UserManDialog"/>
  </div>
</template>

<script>

import UserManDialog from "../common/UserManDialog";
import OrganizationalStructure from "../common/OrganizationalStructure.vue";

export default {
  name: "UserManagement",
  components: {UserManDialog,OrganizationalStructure},
  data() {
    return {
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        input2:"",
      tableData: [],
      options: [{

          value: '1',
          label: '全部'
        }, {
          value: '2',
          label: '正常'
        }, {
          value: '3',
          label: '已锁'
        }],
        value: '',
       optionsone: [{
          valueone: '1',
          labelone: '全部'
        }, {
          valueone: '2',
          labelone: '正式员工'
        }, {
          valueone: '3',
          labelone: '外包员工'
        }],
        valueone: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      companyId:"",
      officeId:"",
      AllData:"",
      officeName:"",
      company:"",
      department:"",
      LoginNm:"",
      UserNm:"",
      instrument:"",
      userType:"",

      userRight:[],
      serviceUserType:[],

    }
  },
  methods: {
    Inquire(){
      
      if(this.valueone == "1" ){
        this.userType = "全部"
      }else if(this.valueone == "2" ){
        this.userType = "正式员工"
      }else{
        this.userType = "外包员工"
      }
      let obj = {
        "companyName":this.company,
        "officeName":this.department,
        "loginName":this.LoginNm,
        "userName":this.UserNm,
        "userType":this.userType,
        "no":this.instrument,
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
      }
        this.$http.post(this.$requestUrl.POST_USER_LIST,obj).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            if(data.data == null){
              this.loading = false
            }else{
              this.loading = false
            this.total = data.data.total
            this.tableData = data.data.records;
            }
          } else {
            this.loading = false
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.loading = false
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })

    },
    getMsgFormSon(data){
      this.AllData = data
      this.getAllMenu()
    },
   handleSizeChange(val) {
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.getAllMenu()
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
      }
        this.$http.post(this.$requestUrl.POST_USER_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      },

    editMenu(row) { // 修改
      this.$http.get(this.$requestUrl.GET_ROLE_JUR+row.userId).then((res) => {
            let result = res.data;
            if (200 === result.code) {
              let arr = []
              for(let val of result.data.userRole){
                arr.push(val.roleId)
              }
              row.userEmail = res.data.data.userEmail
              row.userNo = res.data.data.userNo
              row.userPhone = res.data.data.userPhone
              this.$refs.UserManDialog.userRightVal = arr
              this.$refs.UserManDialog.userTypeVal = res.data.data.userType
              this.$refs.UserManDialog.title = "用户修改";
              this.$refs.UserManDialog.dialogVisible = true; 
              this.$refs.UserManDialog.ifelse = "1"; 
              this.$refs.UserManDialog.formLabelAlign = row
              this.$refs.UserManDialog.userRight = this.userRight
              this.$refs.UserManDialog.userType = this.serviceUserType
            }else{
              this.$message.error(result.msg)
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
    },
    addNextMenu(row) { // 重置密码
            let obj = {
              "id":row.userId
            }
            this.$confirm('您确认要重置当前账号的密码, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.put(this.$requestUrl.PUT_RESE_PWD,obj).then((res) => {
            let result = res.data;
            if (200 === result.code) {
              this.$message({
                type: 'success',
                message: '重置成功!'
              });
            }else{
              this.$message.error(result.msg)
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置'
          });          
        });
    },
    delMenu(row) { // 删除
    this.$confirm('您确认要删除当前账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        this.$http.delete(this.$requestUrl.DELETE_USER+row.userId).then((res) => {
        let result = res.data;
        if (200 === result.code) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
        }else{
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    serviceType(){
      let obj = {
        "type": "sys_user_type"
      }
            this.$http.post(this.$requestUrl.POST_USER_TYPE,obj).then((res) => {
            let result = res.data;
            if (200 === result.code) {
              this.serviceUserType = res.data.data
            }else{
              this.$message.error(result.msg)
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
    },
    Jurisdiction(){
      this.$http.get("/sys/web/get/userRole/by/dataScope").then((res) => {
            let result = res.data;
            if (200 === result.code) {
              this.userRight = res.data.data
            }else{
              this.$message.error(result.msg)
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
    },
  },
  mounted() {
    this.serviceType()
    this.getAllMenu();
    this.Jurisdiction()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>